import {
  APPLIED_JOBS_QUERY_KEY,
  RECOMMENDED_JOBS_QUERY_KEY,
  SAVED_JOBS_QUERY_KEY,
} from "@/lib/queryKeys";
import { JobsTab } from "@monsterindia/seeker-jobs";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import React from "react";

import { PageSpecificDataProps } from "../types";
import { RECOMMENDED } from "./constants/dashboardTabs";

type DashboardTabsProps = {
  activeTab: string;
  pageSpecificData: PageSpecificDataProps;
  setActiveTab: (tab: string) => void;
  setClientTabSwitch: (clientTabSwitch: boolean) => void;
  isMobile?: boolean;
};
const DashboardTabs = ({
  activeTab,
  pageSpecificData,
  setActiveTab,
  setClientTabSwitch,
  isMobile,
}: DashboardTabsProps) => {
  const router = useRouter();
  const queryClient = useQueryClient();

  const handleResetQuery = () => {
    queryClient.removeQueries({
      queryKey: [APPLIED_JOBS_QUERY_KEY],
      exact: false,
    });
    queryClient.removeQueries({
      queryKey: [RECOMMENDED_JOBS_QUERY_KEY],
      exact: false,
    });
    queryClient.removeQueries({
      queryKey: [SAVED_JOBS_QUERY_KEY],
      exact: false,
    });
  };

  const setSearchParams = (tab: string) => {
    router.push(`?activeTab=${tab}&ts=${Date.now()}`);
    const cleanupWhenReady = setInterval(() => {
      const currentUrl = window.location.search;
      if (currentUrl.includes("ts=")) {
        clearInterval(cleanupWhenReady);
        const updatedParams = new URLSearchParams(currentUrl);
        updatedParams.delete("ts");
        window.history.replaceState(null, "", `?${updatedParams.toString()}`);
      }
    }, 0);
  };

  const handleTabClick = async (tab: string) => {
    pageSpecificData.setRecommendedDashboardData({ multiSelectCount: 0 });
    handleResetQuery();
    setSearchParams(tab);
    setActiveTab(tab);
    setClientTabSwitch(true);
  };

  return (
    <div className="md:bg-surface-pri bg-surface-primary-normal flex items-center justify-center py-4 md:!mb-0 md:py-0 md:!pt-5">
      <JobsTab
        isMobile={isMobile}
        onTabChange={(data: string) => {
          if (
            activeTab == RECOMMENDED &&
            pageSpecificData?.recommendedDashboardData?.multiSelectCount > 0
          ) {
            if (
              window.confirm(
                "If you leave now, your selection will be cleared. Discard your changes?",
              )
            ) {
              handleTabClick(data);
            }
          } else {
            handleTabClick(data);
          }
        }}
        selectedTab={activeTab}
      />
    </div>
  );
};
export default React.memo(DashboardTabs);
